import { tx as translateInterfaceText } from '@/utils/i18n';
/**
 * Plataformas suportadas pela Notificação de Vendas — fonte única do editor e
 * do preview do player.
 *
 * `value` é exatamente o que vai gravado em `salesNotification.platform` no
 * Mongo: `perfectpay`, `monetizze` e `vegaCheckout` já existem em documentos
 * antigos e NÃO podem ser renomeados — por isso `vegaCheckout` é camelCase
 * enquanto todos os outros (e todos os arquivos) são minúsculos.
 *
 * `icon` aponta para public/assets/logo-companies, servido como URL pública em
 * vez de import do bundler: são 12 imagens que só uma delas aparece por vez,
 * não faz sentido embutir todas no bundle. O arquivo segue sempre o slug
 * minúsculo da plataforma — o mesmo conjunto que o player usa em
 * imgs/sales-platforms/.
 *
 * A ordem desta lista é a ordem do seletor no painel (alfabética pelo nome
 * exibido); `custom` fica fora dela porque não tem logo fixa — usa o
 * `customPlatformIcon` enviado pelo usuário — e é renderizado por último.
 */
export interface SalesNotificationPlatform {
  value: string;
  label: string;
  icon: string;
}

export const SALES_NOTIFICATION_PLATFORMS: SalesNotificationPlatform[] = [
  { value: 'braip', get label() { return translateInterfaceText("Braip"); }, icon: '/assets/logo-companies/braip.webp' },
  { value: 'cakto', get label() { return translateInterfaceText("Cakto"); }, icon: '/assets/logo-companies/cakto.webp' },
  { value: 'cartpanda', get label() { return translateInterfaceText("CartPanda"); }, icon: '/assets/logo-companies/cartpanda.webp' },
  { value: 'digitalguru', get label() { return translateInterfaceText("Digital Guru"); }, icon: '/assets/logo-companies/digitalguru.webp' },
  { value: 'eduzz', get label() { return translateInterfaceText("Eduzz"); }, icon: '/assets/logo-companies/eduzz.webp' },
  { value: 'hotmart', get label() { return translateInterfaceText("Hotmart"); }, icon: '/assets/logo-companies/hotmart.webp' },
  { value: 'kirvano', get label() { return translateInterfaceText("Kirvano"); }, icon: '/assets/logo-companies/kirvano.webp' },
  { value: 'kiwify', get label() { return translateInterfaceText("Kiwify"); }, icon: '/assets/logo-companies/kiwify.webp' },
  { value: 'monetizze', get label() { return translateInterfaceText("Monetizze"); }, icon: '/assets/logo-companies/monetizze.webp' },
  { value: 'perfectpay', get label() { return translateInterfaceText("Perfect Pay"); }, icon: '/assets/logo-companies/perfectpay.webp' },
  { value: 'ticto', get label() { return translateInterfaceText("Ticto"); }, icon: '/assets/logo-companies/ticto.webp' },
  { value: 'vegaCheckout', get label() { return translateInterfaceText("Vega"); }, icon: '/assets/logo-companies/vegacheckout.webp' },
];

// Platform icon URLs
export const PLATFORM_ICONS: Record<string, string> = Object.fromEntries(
  SALES_NOTIFICATION_PLATFORMS.map((platform) => [platform.value, platform.icon]),
);

// Platform display names (inclui `custom`, que aparece no alt da imagem)
export const PLATFORM_DISPLAY_NAMES: Record<string, string> = {
  ...Object.fromEntries(SALES_NOTIFICATION_PLATFORMS.map((p) => [p.value, p.label])),
  custom: 'Personalizado',
};
